const splitText = (text: string, highlightedWord: string): [string, string] => {
  if (!highlightedWord.trim() || !text.includes(highlightedWord))
    return [text, ""]

  const [firstSection, ...rest] = text.split(highlightedWord)
  const secondSection = rest.join(highlightedWord)

  return [firstSection, secondSection]
}

export default splitText
